import React, { useState, useContext } from 'react';
import PropTypes from 'prop-types';
import { AddToCartContext } from './AddToCartContext';
import CartItem from './CartItem';

import './CartDropdown.css'
import '../buttons/WishlistSharingButton.css'
import CartDropdownFooter from './CartDropdownFooter';
import CartDropdownFooterText from './CartDropdownFooterText';
import WishlistSharingButton from '../buttons/WishlistSharingButton';
import { isMobileDevice } from "../../../utils/DeviceDetector";
import { getMobileOS } from 'web-store-modules/packages/obsess-device-detector';
import ReactHtmlParser from 'react-html-parser';
import { withTranslation } from 'react-i18next';
import { BagCheckoutButtonClicked, WhatsAppCartButtonAnalytics } from '../../../utils/Analytics';
import { formatPriceString } from '../modals/product/extended-product-modal/util/ProductModalHelpers';
import WishlistEmailModal from '../modals/wishlist-email/WishlistEmailModal';


const isMobile = isMobileDevice();
const preCheckoutURL = 'https://test.ferragamo.com/shop/us/en/mycart?addItems=';
const whatsappIcon = 'https://cdn.obsess-vr.com/mary-kay/Whatsapp.png';
const emailIcon = 'https://cdn.obsess-vr.com/mary-kay/Email.png';
const shareIcon = "https://cdn.obsess-vr.com/ferragamo/share2.svg";

const CartDropdown = ({ showDropdown, menuTextFontStyle, wishlistFontStyle, currentLanguage, currentSceneName, t }) => {
    const { cartList, pricePrefix, removeFromCart } = useContext(AddToCartContext);
    const [showShareIcon, setShowShareIcon] = useState(false);
    const [showEmailAcqModal, setShowEmailAcqModal] = useState(false);
    
    const popupFormHandler = (type) => {
        if (type === t('wishlistCartDropdown4')) {
            setShowEmailAcqModal(true);
        }
    }
    const placeOrderUrl = () => {
        const langUrl = (currentLanguage === 'kor_kr') ? 'kor/ko' : currentLanguage.replace('_', '/');
        let urlStr = `https://www.ferragamo.com/shop/${langUrl}/mycart?addItems=`;
        cartList.map((item, index) => {
            const sep = ((index + 1) < cartList.length) ? ';' : '';
            urlStr += `${item.SKU},${item.QTY}${sep}`
        });
        BagCheckoutButtonClicked();
        const suffixUrl = "&utm_source=houseofgift&utm_medium="+currentLanguage+"&utm_campaign=holiday21&utm_content="+currentSceneName+"_shoppingbag";
        window.open(urlStr+suffixUrl, '_blank');
    }

    const renderCartItems = () => {
        return (
            <div className='cart-dropdown-item-container'>
                {cartList.map((item, index) => {
                    return (
                        <CartItem
                            key={index}
                            sku={item.SKU}
                            name={item.TITLE}
                            price={item.PRICE}
                            size={item.SIZE}
                            pricePrefix={item.PRICE_PREFIX}
                            thumbnail={item.DOWNSIZED_THUMBNAIL}
                            menuTextFontStyle={menuTextFontStyle}
                            removeFromCart={removeFromCart}
                            quantity={item.QTY}
                            width={item.WIDTH}
                            color={item.COLOR}
                            currentLanguage={currentLanguage}
                            isCartDropDown={true}
                        />
                    )
                })}
            </div>
        );
    }

    const getTotalPrice = () => {
        let totalPrice = 0;
        cartList.map((item, index) => {
            totalPrice = totalPrice + (item.PRICE ? (item.QTY ? (item.QTY * item.PRICE) : item.PRICE) : 0);
        });
        return formatPriceString(totalPrice, currentLanguage)
    }

    const renderSharingButtons = () => {

        const wishListEmail = cartList.map(item => {
            return `   ` + ReactHtmlParser(item.TITLE) + `  ` + item.PRICE;
        })

        const utmUrlWhatsapp = `?utm_source=houseofgift&utm_medium=${currentLanguage}&utm_campaign=holiday21&utm_content${currentSceneName}_cartwhatsapp`;

        const wishList = cartList.map(item => {
            return `\n${t('whatsApp2')}:  ` + item.TITLE + `\n${t('whatsApp3')}:  ` + item.PRICE + `\nUrl:  ` + item.URL+utmUrlWhatsapp;
        })
        const subject = t('whatsApp1');
        const body = `Here’s a list of favorite products from my latest visit to Ferragamo`;

        const emailLink = `mailto:?subject=${subject}&body=${body}` + " " + encodeURIComponent(wishListEmail.join('; ') + ';');
        const whatsappLink = "https://web.whatsapp.com/send?text=" + subject + encodeURIComponent(wishList.join('\n'));
        const whatsappMobileLink = "whatsapp://send?text=" + subject + encodeURIComponent(wishList.join('\n'));

        const onShareButtonClicked = () => {
            setShowShareIcon(!showShareIcon);
        }

        return (
            <div style={{ width: 'auto' }}>
                {/* <div className='wishlist-sharing-heading'>{t('wishlistIBCText')}</div> */}
                {/* <div className='wishlist-price-text'>PriceText</div> */}
                <div className="share-panel">
                    <button onClick={onShareButtonClicked} className="call-to-order-btn-wrapper share" style={{ margin: '15px auto', cursor: 'pointer', border: 'none', backgroundColor: 'transparent' }} >
                        <img src={shareIcon} style={{ filter: 'invert(1)' }}/>
                    </button>
                    {showShareIcon &&
                        <WishlistSharingButton className="dark-bg" isCentered={true} sharingType={t('wishlistCartDropdown4')} sharingIcon={emailIcon} openPopForm={popupFormHandler} onClick={()=>{}}/>
                    }
                    {showShareIcon &&
                        <WishlistSharingButton className="dark-bg" isCentered={true} sharingType={t('wishlistCartDropdown5')} sharingIcon={whatsappIcon} sharingLink={isMobile ? whatsappMobileLink : whatsappLink} onClick={WhatsAppCartButtonAnalytics}/>
                    }
                </div>
            </div>
        );
    }
    const renderWishlistEmailModal = () => {
        return (
            <WishlistEmailModal
                showModal={showEmailAcqModal}
                menuTextFontStyle={menuTextFontStyle}
                onCLoseCallback={e => setShowEmailAcqModal(false)}
            />
        )
    }

    if (!showDropdown) {
        return (<div />);
    }
    return (
        <React.Fragment>
            {renderWishlistEmailModal()}
            {cartList.length !== 0 && <div id='add-to-cart-arrow' />}
            <div id='add-to-cart-menu'>
                {renderCartItems()}
                {cartList.length !== 0 && <div className="est-total">
                    <span>{t('cartEstimatedTotal')}</span>
                    <span>{getTotalPrice()}</span>
                </div>}
                {cartList.length !== 0 && <CartDropdownFooter onClick={placeOrderUrl} />}
                {cartList.length !== 0 && wishlistFontStyle.text && <CartDropdownFooterText wishlistFontStyle={wishlistFontStyle} />}
                {cartList.length !== 0 && renderSharingButtons()}
            </div>
        </React.Fragment>
    );
}

CartDropdown.propTypes = {
    showMenu: PropTypes.bool,
    linkedStores: PropTypes.array,
    currentStoreIndex: PropTypes.number,
    menuTextFontStyle: PropTypes.object,
    menuTitle: PropTypes.string,
    sceneIdNameDict: PropTypes.object,
};

export default withTranslation()(CartDropdown);
